import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";

const TITLE = "Over ons — Belgisch digital agency | IT Solutions";
const DESC =
  "IT Solutions combineert AI-snelheid met menselijke engineering. Top 0.1% beoordeeld, 27 live projecten in 45 dagen, gevestigd in België met EU-hosting.";

import { OverOnsPage } from "@/pages/over-ons";

export const Route = createFileRoute("/over-ons")({
  head: () =>
    pageHead({ lang: "nl", pathWithoutLang: "/over-ons", title: TITLE, description: DESC }),
  component: OverOnsPage,
});
